import { defineField, defineType } from "sanity";

export const categoryContentType = defineType({
  type: "document",
  name: "categoryContent",
  title: "Category Content",
  groups: [
    { name: "meta", title: "Meta" },
    { name: "modules", title: "Modules" }
  ],
  fields: [
    defineField({
      name: "title",
      type: "string",
      title: "Title",
      validation: (Rule) => Rule.required(),
      group: "meta"
    }),
    defineField({
      name: "slug",
      type: "slug",
      title: "Slug",
      validation: (Rule) => Rule.required(),
      options: {
        source: "title",
        maxLength: 96
      },
      group: "meta"
    })
  ]
});
